export default function registerUser(state = {}, action) {
  switch (action.type) {
    case "REGISTER_REQUEST":
      return { registering: true };
    case "REGISTER_SUCCESS":
      return { success: true };
    case "REGISTER_FAILURE":
      return {};
    default:
      return state
  }
}